/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_Camera_Config_ErrorInputs */

const vi_fleet_camera_config_error = /** @type {(inputs: Fleet_Camera_Config_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera xe này chưa được cấu hình đúng. Đã báo quản trị.`)
};

/**

* @param {Fleet_Camera_Config_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_camera_config_error = /** @type {((inputs?: Fleet_Camera_Config_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Camera_Config_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_camera_config_error(inputs)
});